declare namespace $ {

	type $mol_view__sub_shm_radio_1 = $mol_type_enforce<
		ReturnType< $shm_radio['circle_inner'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_radio extends $mol_check {
		Circle_inner( ): $mol_view
		circle_inner( ): readonly(any)[]
		aria_role( ): string
		Icon( ): $mol_view
	}
	
}

//# sourceMappingURL=radio.view.tree.d.ts.map